<style scoped xmlns="http://www.w3.org/1999/html">

    .appcontent {
        width: 900px;
        height: 800px;
    }

    .wrapper {
        min-width: 650px;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
    }

    .block {
        min-width: 650px;
        padding: 0.2rem;
        background-color: #115555;
        min-height: 400px;
    }
    .item {
        display: flex;
        width: 650px;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
        margin-top: 10px;
    }
</style>

<template>
    <div id="appcontent">
        <div class="wrapper" @click.stop>
            <div class="block">
                <h2>app竖屏内容录入</h2>
                <div class="item" v-for="(item,index)  in appContents" :key="index">
                    <img :src="item.imgUrl" style="height: 1.2rem;width: 1.2rem;margin-left: 0.1rem;margin-right: 0.1rem"  >
                    <Input v-model="item.text1" placeholder="文本1" style="width: 100px" />
                    <Input v-model="item.text2" placeholder="文本2" style="width: 100px" />
                    <Input v-model="item.text3" placeholder="文本3" style="width: 100px" />
                    <div style="display: flex;flex-direction: row;align-items: center;width: 200px;justify-content: space-around">
                        <Upload class=""
                                action=""
                                :show-file-list="false"
                                :before-upload="beforeAvatarUpload">
                            <Button @click="updateIndex(index)">上传图片</Button>
                        </Upload>
                        <Button type="primary" @click="saveItem(item)">保存</Button>
                        <Button type="error" @click="delItem(item,index)">删除</Button>
                    </div>


                </div>


                <Button type="dashed" long style="margin-top: 0.2rem" @click="addItem">新增</Button>
            </div>
        </div>
    </div>

</template>

<script>
    import {fullScreen} from "../layout/components/headerBar_components";
    import nopic from '@/assets/img/no_pic.png';
    import bgPic from '../daping/assets/img/bgs.png';
    export default {
        name: "appcontent",
        data() {
            // 统计图对象
            return {
                curIndex:0,
                appContents:[]
            }
        },
        computed: {},
        beforeCreate() {
            //设置背景色
            document.querySelector("body").setAttribute("style", "background:#fbfbfb");
        },
        beforeDestroy() {
            //去除背景色
            document.querySelector("body").setAttribute("style", "");
        },
        beforeMount() {

        },
        created(){
            var that = this;
            setTimeout(function () {
                that.listAppContent();
            },2000)

        },

        mounted() {
        },
        watch: {},
        methods: {
            updateIndex(index){
              this.curIndex=index
            },
            delItem(item,index){
                var that = this;
                if (item.id==0){
                    this.appContents.splice(index, 1)
                    return
                }
                that.$func.ajax('delItem',item , function (r) {
                    if (!r.statusCode) {
                        that.$func.msg(r.message);
                    } else {
                        that.listAppContent()
                    }
                })
            },
            saveItem(item){
                var that = this;
                that.$func.ajax('saveAppItem',item , function (r) {
                    if (!r.statusCode) {
                        that.$func.msg(r.message);
                    } else {
                        that.listAppContent()
                    }
                })
            },
            //上传地图之前
            addItem(){
                var that=this
              this.appContents.push({
                  id:0,imgUrl:'',text1:'',text2:'',text3:'',areaId:that.$store.state.app.areaId
              })
            },
            beforeAvatarUpload(file) {
                console.log(file)
                if (file.type.indexOf('image') != -1) {
                    let reader = new FileReader();
                    var that = this
                    reader.onload = function (evt) {
                        let base64 = evt.target.result;
                        that.updatePic(base64);
                    };
                    reader.readAsDataURL(file);
                } else {
                    this.$Notice.warning({
                        title: '文件格式不正确',
                        desc: '文件格式 ' + file.name + ' 不正确, 请选择 jpg 或 png'
                    });
                }
                return true;
            },

            updatePic(base64){
                let that = this;
                that.$Message.loading({
                    content: '上传中...',
                    duration: 0
                });
                that.$func.ajax('upImg',{
                    token : that.$func.getUserInfo('token'),
                    img64 : base64,
                },function(r){
                    that.$Message.destroy()
                    if(!r.statusCode){
                        that.$func.msg(r.message,'error');
                    }else{
                        console.log(r.type)
                        var url="http://xhjg.oss-cn-beijing.aliyuncs.com"+r.type;
                        that.appContents[that.curIndex].imgUrl=url

                    }
                },'','post',false)
            },
            listAppContent() {
                var that = this;
                that.$func.ajax('listAppContent', {
                    token:  that.$func.getToken(),
//                    areaId:434
                    areaId: that.$store.state.app.areaId,
                }, function (r) {
                    if (!r.statusCode) {
                        that.$func.msg(r.message);
                    } else {
                        that.appContents = r.type;
                    }
                })
            },

        }
    };
</script>
